import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { updateTableBd } from '../../config/functions'
import { toast } from 'react-toastify'

export const DOReportVerificar = ({
    idrde,
    setUsuarioVerifica,
    getDetalleEmpleados,

    cuadrilla1,
    cuadrilla2,
    cuadrilla3,
    cuadrilla4,
    cuadrilla5,

    supervisores,

    tipo24Ok,

    reporteActividades,
    getEncabezado
}) => {

    const verificarReporte = async () => {
        if (!tipo24Ok.COMPANYMAN) {
            toast.warning('Falta el registro de Companyman')
            return
        }
        if (!tipo24Ok.PUSHER) {
            toast.warning('Falta el registro del Jefe de equipo o Pusher')
            return
        }
        if (!tipo24Ok.HSE) {
            toast.warning('Falta el registro de HSE')
            return
        }
        if (!tipo24Ok.ELECTRICISTA) {
            toast.warning('Falta el registro de Electricista')
            return
        }
        if (!tipo24Ok.MECANICO) {
            toast.warning('Falta el registro de Mecánico')
            return
        }
        if (supervisores <= 1) {
            toast.warning('Falta registros de supervisores')
            return
        }
        if (cuadrilla1 === 0) {
            toast.warning('No hay registros en la cuadrilla 1')
            return
        }
        if (cuadrilla2 === 0) {
            toast.warning('No hay registros en la cuadrilla 2')
            return
        }
        if (cuadrilla3 === 0) {
            toast.warning('No hay registros en la cuadrilla 3')
            return
        }
        if (cuadrilla4 === 0) {
            toast.warning('No hay registros en la cuadrilla de Descanso')
            return
        }
        if (cuadrilla5 === 0) {
            toast.warning('No hay registros en los obreros de patio')
            return
        }

        if (reporteActividades.length === 0) {
            toast.warning('No hay registros de actividades')
            return
        }

        const existeRegistroCompleto = reporteActividades.some(
            r => r.desde === '00:00' && (r.hasta === '24:00' || r.hasta === '00:00')
        );

        if (reporteActividades[reporteActividades.length - 1].hasta !== '00:00' && !existeRegistroCompleto) {
            toast.warning('No ha finalizado el reporte de actividades')
            return
        }

        if (window.confirm('Esta seguro de continuar con la verificación, recuerde que después de verificado no podrá modificar?')) {
            const fecha = new Date()
            fecha.setHours(fecha.getHours() - 5);
            const dataSend = {
                id: parseInt(idrde),
                usuario_verifica: JSON.parse(localStorage.getItem("token")).userName,
                fecha_verifica: fecha
            }
            const response = await updateTableBd('updateregistrediarioEVerificar', dataSend)
            if (response) {
                setUsuarioVerifica(dataSend.usuario_verifica)
                await getEncabezado()
                await getDetalleEmpleados()
                toast.success('Reporte verificado exitosamente')
            } else {
                toast.error('Error al verificar el reporte.')
            }
        }
    }

    return (
        <Row className="my-3 justify-content-md-center">
            <Col sm={3} >
                <button className="btn btn-primary btn-sm "
                    onClick={() => verificarReporte()} >
                    Verificar
                </button>
            </Col>
        </Row>
    )
}
